/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AddRuleCardViewModel {
  id?: string;
  rowId?: number;
  datasetId?: string;
  ruleCardTypeId?: string;
  ruleCardSubtypeId?: string;
  description?: string | null;
  result?: string | null;
  ruleCardResultId?: string;
  isDeleted?: boolean;
  rootId?: string;
  criteriaString?: string | null;
}
